<!--
 * @FileDescription: 单据——采购入库详情
 * @Author: ryb
 * @Date: 2020-07-22
 -->
<template>
  <div class="bill-purchase-page">
    <div class="bill-purchase-information" id="page-top">
      <a-row class="ant-row-one">
        <a-col style="display:flex;justify-content: flex-end;" :span="24">
          <a-col>
            <span class="a-col-title">单据单号：</span>
            <span class="a-col-value"> {{ dataDetails.code }}</span>
          </a-col>
          <a-col style="margin-left: 106px">
            <span class="a-col-title">单据日期：</span>
            <span class="a-col-value">{{ dataDetails.voucherDate }}</span>
          </a-col>
        </a-col>
      </a-row>
      <a-row class="ant-row-two">
        <a-col>
          <span class="a-col-title">往来单位：</span>
          <span class="a-col-value">{{ dataDetails.contactCustomerName }}</span>
        </a-col>
        <a-col>
          <span class="a-col-title">出库仓库：</span>
          <span class="a-col-value"> {{ dataDetails.outStorageName }}</span>
        </a-col>
        <a-col v-if="dataDetails.transactorName">
          <span class="a-col-title">经办人：</span>
          <span class="a-col-value"> {{ dataDetails.transactorName }}</span>
        </a-col>
        <a-col v-if="dataDetails.digest">
          <span class="a-col-title">摘要：</span>
          <span class="a-col-value">{{ dataDetails.digest }}</span>
        </a-col>
        <a-col v-if="dataDetails.remark">
          <span class="a-col-title">备注：</span>
          <span class="a-col-value">{{ dataDetails.remark }}</span>
        </a-col>
        <a-col>
          <look-popover :type="3" :dataDetails="dataDetails">
            <span class="border-color" slot="trigger-tag">
              更多
              <a-icon type="right-circle" style="margin-left: 3px" />
            </span>
          </look-popover>
        </a-col>
      </a-row>
    </div>
    <div class="line"></div>
    <div class="bill-purchase-table" :style="{height: contentHeight+'px'}">
      <a-table :columns="columns" :dataSource="dataDetails.salesOrderItemVOList" :pagination="false" rowKey="id" :scroll="{ x:1000,y: (tableHeight) }" bordered>
        <template slot="serialNum" slot-scope="text, record, index">
          <span>{{ index+1 }}</span>
        </template>
        <!-- 商品名称 -->
        <template slot="productName" slot-scope="text, record">
          <a-tooltip>
            <template slot="title" v-if="text">
              <span>{{ text }}</span>
            </template>
            <div class="text-overflow">
              <img src="@/assets/image/zengpin.png" style="width: 22px;margin-right: 5px" v-if="record.giftFlag==1">
              <img src="@/assets/image/manage_zong@2x.png" style="width: 22px" v-if="record.assemblyFlag==1">
              <span class="name-text"> {{ text }}</span>
            </div>
          </a-tooltip>
        </template>
        <!-- 商品编号 -->
        <template slot="productCode" slot-scope="text">
          <a-tooltip>
            <template slot="title" v-if="text">
              <span>{{ text }}</span>
            </template>
            <div class="text-overflow">
              <span class="name-text"> {{ text }}</span>
            </div>
          </a-tooltip>
        </template>
        <!-- 商品备注 -->
        <template slot="remark" slot-scope="text">
          <a-tooltip>
            <template slot="title" v-if="text">
              <span>{{ text }}</span>
            </template>
            <div class="text-overflow">
              <span class="name-text"> {{ text }}</span>
            </div>
          </a-tooltip>
        </template>
        <template slot="footer">
          <div class="footer-total-amount">
            <div class="footer-total-amount-left" style="width: 80px">
              <span class="title">小计</span>
            </div>
            <div class="footer-total-amount-right" v-if="footerDataSource.length>0">
              <span class="right-col">出库数量：{{ footerDataSource[0].productTotalCount }}</span>
              <span class="right-col">金额：{{ footerDataSource[0].productTotalAmount.toFixed(2) }}</span>
            </div>
          </div>
        </template>
      </a-table>
    </div>

    <div class="bill-purchase-price" id="page-button">
      <div class="logistics-information">
        <a-row>
          <a-col>
            <span class="a-col-title">物流方式：</span>
            <span class="a-col-value">{{ dataDetails.distributionMode==1?'客户自提' :'送货上门' }}</span>
          </a-col>
        </a-row>
        <a-row>
          <a-col>
            <span class="a-col-title">是否包含运费：</span>
            <span class="a-col-value">{{ dataDetails.includeFreightFlag==0?'不包括运费' :'包含运费' }}</span>
          </a-col>
        </a-row>
        <a-row v-if="dataDetails.distributionMode==2">
          <a-col>
            <span class="a-col-title">物流公司：</span>
            <span class="a-col-value">{{ dataDetails.logisticsCompanyName }}</span>
          </a-col>
          <a-col>
            <span class="a-col-title">物流单号：</span>
            <span class="a-col-value">{{ dataDetails.trackingNumber }}</span>
          </a-col>
        </a-row>
      </div>
      <div class="price-information">
        <a-row>
          <a-col>
            <span class="price-title">加付费用：</span>
            <span class="price-color">¥ {{ dataDetails.otherExpensesAmount?dataDetails.otherExpensesAmount :0 }}</span>
            <lookPopover :type="2" :dataDetails="dataDetails">
              <span style="color:#387BFC;margin-left:10px;cursor: pointer;" slot="trigger-tag">查看</span>
            </lookPopover>
          </a-col>
          <a-col>
            <span class="price-title">优惠金额：</span>
            <span class="price-color">¥ {{ dataDetails.discountAmount?dataDetails.discountAmount :0 }}</span>
          </a-col>
        </a-row>
        <a-row>
          <a-col>
            <span class="price-title">合计：</span>
            <span class="price-color">¥ <span style="font-size: 40px">{{ dataDetails.totalAmount }}</span></span>
          </a-col>
        </a-row>
      </div>
    </div>

    <public-footer :buttonList="buttonList"></public-footer>
    <preserve-modal ref="preserve"></preserve-modal>
  </div>
</template>
<script>
import pick from 'lodash.pick'
import publicFooter from '@/components/module/publicFooter.vue'
import preserveModal from '@/components/module/preserveModal.vue'
import lookPopover from "./modules/lookPopover.vue"
import { tableWidth } from "@/mixins/tableWidth"
import { getDetailsMethod } from "@/utils/api"
export default {
  name: 'sellOrderLook',
  mixins: [tableWidth],
  components: {
    publicFooter,
    preserveModal,
    lookPopover
  },
  data () {
    return {
      columns: [
        {
          width: 80,
          title: "序号",
          align: "center",
          dataIndex: "serialNum",
          ellipsis: true,
          scopedSlots: { customRender: "serialNum" },
        }, {
          defaultWidth: 200,
          title: "商品名称",
          dataIndex: "productName",
          ellipsis: true,
          scopedSlots: { customRender: "productName" },
        }, {
          defaultWidth: 200,
          title: "商品编号",
          dataIndex: "productCode",
          ellipsis: true,
          scopedSlots: { customRender: "productCode" },
        }, {
          title: "规格",
          ellipsis: true,
          dataIndex: "productSpecification",
        }, {
          title: "型号",
          ellipsis: true,
          dataIndex: "productModel",
        }, {
          title: "单位",
          ellipsis: true,
          dataIndex: "productUnitName",
        }, {
          title: "数量",
          align: "right",
          dataIndex: "productTotalCount",
          ellipsis: true,
        }, {
          title: "售价",
          align: "right",
          dataIndex: "price",
        }, {
          title: "金额",
          align: "right",
          dataIndex: "totalAmount",
          ellipsis: true
        }, {
          defaultWidth: 180,
          title: "备注",
          dataIndex: "remark",
          scopedSlots: { customRender: "remark" },
        }
      ],
      dataSource: [],
      buttonList: [
        {
          id: 7,
          has:"sales_order_print",
          text: '打印',
          templateType: 103
        }
      ],
      footerDataSource: [{
        serialNum: '',
        productName: '',
        productCode: '',
        productSpecification: '',
        productModel: '',
        productUnitName: '',
        productTotalCount: 0,
        productTotalAmount: 0,
        price: '',
        remark: ''
      }],
      contentHeight:'',
      tableHeight: '',
      urlList: {
        details: '/order/api/salesOrder/findSalesOrderById'
      },
      accountsName: null,
      dataDetails: {},
      sellId:null
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.sellId = to.query.id
    this.init()
    this.getMakeDetails()
    next()
  },
  activated () {
    this.sellId = this.$route.query.id
    this.init()
    this.getMakeDetails()
  },
  methods: {
    init () {
      // 表格高度计算
      let _that = this
      setTimeout(function() {
        let tdHeight = document.getElementsByTagName('tr')[0].offsetHeight
        let header = document.getElementById("header").offsetHeight;
        let breadcrumb = document.getElementById("breadcrumb").offsetHeight;
        let pageHeight = document.getElementById('content').offsetHeight
        let makeTop = document.getElementById('page-top').offsetHeight
        let makeButton = document.getElementById('page-button').offsetHeight
        _that.contentHeight = pageHeight - makeTop - makeButton - header - breadcrumb - tdHeight * 1.24
        _that.tableHeight = _that.contentHeight - tdHeight * 2
      }, 50)
    },
    getMakeDetails () {
      let params = new FormData()
      params.append("salesOrderId", this.sellId)
      params.append("companyStoreId", this.$store.state.userInfo.companyStoreId)
      this.$store.state.isLoding = true
      getDetailsMethod(this.urlList.details, params).then((res) => {
        if (res.code == 200) {
          this.dataDetails = res.result
          this.footerDataSource[0].productTotalCount = 0
          this.footerDataSource[0].productTotalAmount = 0
          this.dataDetails.salesOrderItemVOList.map((item, index) => {
            this.footerDataSource[0].productTotalCount += item.productTotalCount
            this.footerDataSource[0].productTotalAmount += item.totalAmount
          })
          this.$store.state.isLoding = false
        } else {
          this.$message.error(res.logMessage)
        }
      })
    }
  }
}
</script>

<style lang="scss">
.bill-purchase-page {
  .bill-purchase-information {
    padding: 15px 40px;
    background-color: #ffffff;
    .ant-row-one {
      padding: 8px 0;
      display: flex;
      justify-content: space-between;
    }
    .ant-row-two {
      padding: 8px 0;
      display: flex;
      flex-wrap: wrap;
      .ant-col {
        padding-right: 80px;
      }
    }
    .border-color {
      color: #f76f14;
      font-size: 14px;
      cursor: pointer;
    }
  }
  .bill-purchase-table {
    background-color: #ffffff;
    .ant-table-wrapper {
      padding: 0;
    }
    .ant-table-thead {
      tr {
        th {
          height: 50px;
          padding: 0 16px !important;
        }
      }
    }
    .ant-table-tbody {
      tr {
        td {
          padding: 0 10px !important;
          height: 54px;
        }
        .product-name-text {
          height: 36px;
          display: flex;
          align-items: center;
          .name-text {
            padding-left: 5px;
          }
        }
        .text-overflow {
          width: 100%;
          height: 36px;
          line-height: 36px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .ant-table-footer {
      padding: 0 5px 0 0;
      td:last-child {
        border-right: 0 !important;
      }
      .ant-table-body {
        border: 0;
      }
    }
  }
  .bill-purchase-price {
    display: flex;
    justify-content: space-between;
    background-color: #ffffff;
    padding: 0 40px;
    margin-top: 16px;
    .logistics-information {
      height: 132px;
      padding: 24px 0;
      display: flex;
      flex-direction: column;
      .ant-row {
        display: flex;
        margin-bottom: 12px;
      }
    }
    .price-information {
      height: 132px;
      padding: 24px 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .ant-row {
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;
        .ant-col {
          margin-left: 42px;
        }
        .price-color {
          font-size: 16px;
          color: #f76f14;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
